import React, { Fragment } from 'react'

import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import HomeMainTest from './HomeMainTest';
import { Breadcrumbs } from '../../AbstractElements';

export default function MainTest() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="List of Lab Tests" parent="Home" title="List of Lab Tests" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <HomeMainTest />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
